import React, { useState } from "react";

import { trans } from '../../../../i18n'
import * as S from './styles'

import { ROUTES } from "../../../../constants";

import { Button } from "../../../../components/Button";
import { useAuthLayout } from "../../../../hooks/useAuthLayout";
import { useSmartNavigate } from "../../../../smartNav/useSmartNavigate";
import type { HotsiteHeaderProps } from './types'

export type { HotsiteHeaderNavLink, HotsiteHeaderProps } from './types'

export const HotsiteHeader = ({
  showDemoButton = true,
  showNavLinks = true,
  extraNavLinks = [],
  logoHeight,
  logoWidth,
  mobileQuickLink,
  contactUrl,
  logoHref,
}: HotsiteHeaderProps): React.ReactElement => {
  const navigate = useSmartNavigate();
  const { logoZingBlack } = useAuthLayout()

  const handleContactClick = (): void => {
    if (contactUrl) {
      window.open(contactUrl, '_blank', 'noopener,noreferrer')
      return
    }
    navigate(ROUTES.HOTSITE.CONTACT, { state: { hotsite: true } })
  }

  const handleLogoClick = (): void => {
    if (logoHref) {
      window.location.href = logoHref
      return
    }
    navigate(ROUTES.HOTSITE.ROOT)
  }

  const [isOpen, setIsOpen] = useState(false);

  const labels = {
    open_challenges: trans('Programas de Inovação'),
    open_events: trans('Eventos'),
    contact: trans('Contato'),
    login: trans('Login'),
    demo: trans('Solicitar Demonstração')
  }

  return (
    <S.HeaderWrapper>
      <S.Container>
        <S.BrandButton onClick={handleLogoClick}>
          <S.Logo src={logoZingBlack} $logoHeight={logoHeight} $logoWidth={logoWidth} alt="Logo" />
        </S.BrandButton>
        {mobileQuickLink && (
          <S.MobileQuickLink onClick={() => navigate(mobileQuickLink.route, { state: { hotsite: true } })}>
            {mobileQuickLink.label}
          </S.MobileQuickLink>
        )}
        <S.ToggleButton aria-controls="navbar" aria-expanded={isOpen} onClick={() => setIsOpen((prev) => !prev)}>
          <S.HamburgerIcon />
        </S.ToggleButton>
        <S.CollapseWrapper id="navbar" $isOpen={isOpen}>
          <S.CollapseInner>
            <S.NavList>
              {showNavLinks && (
                <>
                  <S.HeaderLink onClick={() => navigate(ROUTES.HOTSITE.MARKETPLACE, { state: { hotsite: true } })}>{labels.open_challenges}</S.HeaderLink>
                  <S.HeaderLink onClick={() => navigate(ROUTES.HOTSITE.EVENTS_PAGE, { state: { hotsite: true } })}>{labels.open_events}</S.HeaderLink>
                  <S.HeaderLink onClick={handleContactClick}>{labels.contact}</S.HeaderLink>
                </>
              )}
              {extraNavLinks.map((link) => (
                <S.HeaderLink key={link.route} onClick={() => navigate(link.route, { state: { hotsite: true } })}>
                  {link.label}
                </S.HeaderLink>
              ))}
            </S.NavList>
            <S.LinksWrapper>
              <S.LoginLink
                className='mt-2 mt-lg-0'
                onClick={() => navigate(ROUTES.USER_AUTH.LOGIN, { state: { hotsite: true } })}
              >
                {labels.login}
              </S.LoginLink>
              {showDemoButton && (
                <Button
                  variant="risk"
                  size="sm"
                  onClick={() => navigate(ROUTES.HOTSITE.CONTACT, { state: { hotsite: true } })}
                >
                  {labels.demo}
                </Button>
              )}
            </S.LinksWrapper>
          </S.CollapseInner>
        </S.CollapseWrapper>
      </S.Container>
    </S.HeaderWrapper>
  );
};
